function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell">
        <p>© {new Date().getFullYear()} Periscope Works, LLC</p>
      </div>
    </footer>
  );
}

export default Footer;
